import { CheckboxProps as AntdCheckboxProps } from "antd";
import { DisplaySize, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { StyledCheckbox } from "./styled";
import { CSSProperties, ReactNode } from "react";

export interface CheckboxProps extends AntdCheckboxProps {
  displaySize?: DisplaySize;
  label?: {
    content: ReactNode;
    style?: CSSProperties;
    className?: string;
  };
}

const CheckboxCustom = ({
  displaySize = DISPLAY_SIZES.SMALL,
  children,
  label,
  ...restProps
}: CheckboxProps) => {
  const fontSize = FONT_SIZE[displaySize || "small"];
  return (
    <div className="d-flex align-center gap-2">
      <StyledCheckbox $displaySize={displaySize} {...restProps}>
        {children}
      </StyledCheckbox>
      {label && (
        <div
          style={{
            fontSize: fontSize,
            color: "#fff",
            ...label.style,
          }}
          className={`${label.className ? label.className : ""}`}
        >
          {label.content}
        </div>
      )}
    </div>
  );
};

export default CheckboxCustom;
